<app-card
  class="flex-basis-100 mb-12"
  *ngIf="hasGeneralInfo(metadata) || hasGeneralInfo(originalMetadata)"
>
  <div cardTitle i18n>Informations générales</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.startDate | customDate) !==
                  (metadata.startDate | customDate),
            }"
            >{{ metadata.startDate | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              (originalMetadata.startDate | customDate) !==
                (metadata.startDate | customDate) &&
              (originalMetadata.startDate | customDate) !== null &&
              (originalMetadata.startDate | customDate) !== undefined
            "
            >{{ originalMetadata.startDate | customDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.contractDuration || originalMetadata?.contractDuration"
      >
        <span class="card__label" i18n>Durée du contrat</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.contractDuration !== metadata.contractDuration,
            }"
            >{{ metadata.contractDuration }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.contractDuration !== metadata.contractDuration &&
              originalMetadata.contractDuration !== null &&
              originalMetadata.contractDuration !== undefined
            "
            >{{ originalMetadata.contractDuration }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.paymentFrequency !== null &&
            metadata?.paymentFrequency !== undefined) ||
          (originalMetadata?.paymentFrequency !== null &&
            originalMetadata?.paymentFrequency !== undefined)
        "
      >
        <span class="card__label" i18n>Mode de paiement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                  getPaymentFrequencyLabel(metadata.paymentFrequency),
            }"
            >{{ getPaymentFrequencyLabel(metadata.paymentFrequency) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                getPaymentFrequencyLabel(metadata.paymentFrequency) &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                null &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                undefined
            "
            >{{
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.splitPaymentFee !== null &&
            metadata?.splitPaymentFee !== undefined) ||
          (originalMetadata?.splitPaymentFee !== null &&
            originalMetadata?.splitPaymentFee !== undefined)
        "
      >
        <span class="card__label" i18n
          >Supplément pour paiement fractionné</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.splitPaymentFee !== metadata.splitPaymentFee,
            }"
            >{{ metadata.splitPaymentFee }} %</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.splitPaymentFee !== metadata.splitPaymentFee &&
              originalMetadata.splitPaymentFee !== null &&
              originalMetadata.splitPaymentFee !== undefined
            "
            >{{ originalMetadata.splitPaymentFee }} %</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.totalSalaries !== null &&
            metadata?.totalSalaries !== undefined) ||
          (originalMetadata?.totalSalaries !== null &&
            originalMetadata?.totalSalaries !== undefined)
        "
      >
        <span class="card__label" i18n>Masse des salaires</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.totalSalaries !== metadata.totalSalaries,
            }"
            >{{ metadata.totalSalaries }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.totalSalaries !== metadata.totalSalaries &&
              originalMetadata.totalSalaries !== null &&
              originalMetadata.totalSalaries !== undefined
            "
            >{{ originalMetadata.totalSalaries }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.totalRevenue !== null &&
            metadata?.totalRevenue !== undefined) ||
          (originalMetadata?.totalRevenue !== null &&
            originalMetadata?.totalRevenue !== undefined)
        "
      >
        <span class="card__label" i18n>Chiffre d'affaires</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.totalRevenue !== metadata.totalRevenue,
            }"
            >{{ metadata.totalRevenue }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.totalRevenue !== metadata.totalRevenue &&
              originalMetadata.totalRevenue !== null &&
              originalMetadata.totalRevenue !== undefined
            "
            >{{ originalMetadata.totalRevenue }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.legalProtectionType || originalMetadata?.legalProtectionType
        "
      >
        <span class="card__label" i18n>Type de protection juridique</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessLegalProtectionTypeLabel(
                  originalMetadata.legalProtectionType
                ) !==
                  getBusinessLegalProtectionTypeLabel(
                    metadata.legalProtectionType
                  ),
            }"
            >{{
              getBusinessLegalProtectionTypeLabel(metadata.legalProtectionType)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessLegalProtectionTypeLabel(
                originalMetadata.legalProtectionType
              ) !==
                getBusinessLegalProtectionTypeLabel(
                  metadata.legalProtectionType
                ) &&
              getBusinessLegalProtectionTypeLabel(
                originalMetadata.legalProtectionType
              ) !== null &&
              getBusinessLegalProtectionTypeLabel(
                originalMetadata.legalProtectionType
              ) !== undefined
            "
            >{{
              getBusinessLegalProtectionTypeLabel(
                originalMetadata.legalProtectionType
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasclaimsLastFiveYears !== null &&
            metadata?.hasclaimsLastFiveYears !== undefined) ||
          (originalMetadata?.hasclaimsLastFiveYears !== null &&
            originalMetadata?.hasclaimsLastFiveYears !== undefined)
        "
      >
        <span class="card__label" i18n
          >A subi des sinistres ces 5 dernières années</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasclaimsLastFiveYears) !==
                  getBooleanLabel(metadata.hasclaimsLastFiveYears),
            }"
            >{{ getBooleanLabel(metadata.hasclaimsLastFiveYears) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasclaimsLastFiveYears) !==
                getBooleanLabel(metadata.hasclaimsLastFiveYears) &&
              getBooleanLabel(originalMetadata.hasclaimsLastFiveYears) !==
                null &&
              getBooleanLabel(originalMetadata.hasclaimsLastFiveYears) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.hasclaimsLastFiveYears)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.claims || originalMetadata?.claims"
      >
        <span class="card__label" i18n>Détails des sinistres</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && originalMetadata.claims !== metadata.claims,
            }"
            >{{ metadata.claims }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.claims !== metadata.claims &&
              originalMetadata.claims !== null &&
              originalMetadata.claims !== undefined
            "
            >{{ originalMetadata.claims }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.insurees) ||
    !isSectionEmpty(originalMetadata?.insurees)
  "
>
  <div cardTitle i18n>Personnes assurées</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.insurees.companyAndCollaborators !== null &&
            metadata?.insurees.companyAndCollaborators !== undefined) ||
          (originalMetadata?.insurees.companyAndCollaborators !== null &&
            originalMetadata?.insurees.companyAndCollaborators !== undefined)
        "
      >
        <span class="card__label" i18n>L'entreprise et ses collaborateurs</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.insurees.companyAndCollaborators
                ) !==
                  getBooleanLabel(metadata?.insurees.companyAndCollaborators),
            }"
            >{{
              getBooleanLabel(metadata?.insurees.companyAndCollaborators)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.insurees.companyAndCollaborators
              ) !==
                getBooleanLabel(metadata?.insurees.companyAndCollaborators) &&
              getBooleanLabel(
                originalMetadata?.insurees.companyAndCollaborators
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.insurees.companyAndCollaborators
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.insurees.companyAndCollaborators
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.insurees.partners !== null &&
            metadata?.insurees.partners !== undefined) ||
          (originalMetadata?.insurees.partners !== null &&
            originalMetadata?.insurees.partners !== undefined)
        "
      >
        <span class="card__label" i18n>Les associés</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.insurees.partners) !==
                  getBooleanLabel(metadata?.insurees.partners),
            }"
            >{{ getBooleanLabel(metadata?.insurees.partners) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.insurees.partners) !==
                getBooleanLabel(metadata?.insurees.partners) &&
              getBooleanLabel(originalMetadata?.insurees.partners) !== null &&
              getBooleanLabel(originalMetadata?.insurees.partners) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata?.insurees.partners) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.insurees.administrators !== null &&
            metadata?.insurees.administrators !== undefined) ||
          (originalMetadata?.insurees.administrators !== null &&
            originalMetadata?.insurees.administrators !== undefined)
        "
      >
        <span class="card__label" i18n>Les administrateurs</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.insurees.administrators) !==
                  getBooleanLabel(metadata?.insurees.administrators),
            }"
            >{{ getBooleanLabel(metadata?.insurees.administrators) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.insurees.administrators) !==
                getBooleanLabel(metadata?.insurees.administrators) &&
              getBooleanLabel(originalMetadata?.insurees.administrators) !==
                null &&
              getBooleanLabel(originalMetadata?.insurees.administrators) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.insurees.administrators)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.insurees.commiteeMembers !== null &&
            metadata?.insurees.commiteeMembers !== undefined) ||
          (originalMetadata?.insurees.commiteeMembers !== null &&
            originalMetadata?.insurees.commiteeMembers !== undefined)
        "
      >
        <span class="card__label" i18n>Les membres du comité</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.insurees.commiteeMembers) !==
                  getBooleanLabel(metadata?.insurees.commiteeMembers),
            }"
            >{{ getBooleanLabel(metadata?.insurees.commiteeMembers) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.insurees.commiteeMembers) !==
                getBooleanLabel(metadata?.insurees.commiteeMembers) &&
              getBooleanLabel(originalMetadata?.insurees.commiteeMembers) !==
                null &&
              getBooleanLabel(originalMetadata?.insurees.commiteeMembers) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.insurees.commiteeMembers)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.insurees.contractlessFamilyMembers !== null &&
            metadata?.insurees.contractlessFamilyMembers !== undefined) ||
          (originalMetadata?.insurees.contractlessFamilyMembers !== null &&
            originalMetadata?.insurees.contractlessFamilyMembers !== undefined)
        "
      >
        <span class="card__label" i18n
          >Les membres de la famille sans contrat de travail</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.insurees.contractlessFamilyMembers
                ) !==
                  getBooleanLabel(metadata?.insurees.contractlessFamilyMembers),
            }"
            >{{
              getBooleanLabel(metadata?.insurees.contractlessFamilyMembers)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.insurees.contractlessFamilyMembers
              ) !==
                getBooleanLabel(metadata?.insurees.contractlessFamilyMembers) &&
              getBooleanLabel(
                originalMetadata?.insurees.contractlessFamilyMembers
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.insurees.contractlessFamilyMembers
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.insurees.contractlessFamilyMembers
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.insurees.contractlessFreelanceCollaborateurs !== null &&
            metadata?.insurees.contractlessFreelanceCollaborateurs !==
              undefined) ||
          (originalMetadata?.insurees.contractlessFreelanceCollaborateurs !==
            null &&
            originalMetadata?.insurees.contractlessFreelanceCollaborateurs !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Les collaborateurs libres sans contrat de travail</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.insurees.contractlessFreelanceCollaborateurs
                ) !==
                  getBooleanLabel(
                    metadata?.insurees.contractlessFreelanceCollaborateurs
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata?.insurees.contractlessFreelanceCollaborateurs
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.insurees.contractlessFreelanceCollaborateurs
              ) !==
                getBooleanLabel(
                  metadata?.insurees.contractlessFreelanceCollaborateurs
                ) &&
              getBooleanLabel(
                originalMetadata?.insurees.contractlessFreelanceCollaborateurs
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.insurees.contractlessFreelanceCollaborateurs
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.insurees.contractlessFreelanceCollaborateurs
              )
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.coverages) ||
    !isSectionEmpty(originalMetadata?.coverages)
  "
>
  <div cardTitle i18n>Prestations d'assurances</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.roadTraffic !== null &&
            metadata?.coverages.roadTraffic !== undefined) ||
          (originalMetadata?.coverages.roadTraffic !== null &&
            originalMetadata?.coverages.roadTraffic !== undefined)
        "
      >
        <span class="card__label" i18n
          >PJ en matière de circulation routière</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.coverages.roadTraffic) !==
                  getBooleanLabel(metadata?.coverages.roadTraffic),
            }"
            >{{ getBooleanLabel(metadata?.coverages.roadTraffic) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.coverages.roadTraffic) !==
                getBooleanLabel(metadata?.coverages.roadTraffic) &&
              getBooleanLabel(originalMetadata?.coverages.roadTraffic) !==
                null &&
              getBooleanLabel(originalMetadata?.coverages.roadTraffic) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.coverages.roadTraffic)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.companyVehiclesCount !== null &&
            metadata?.coverages.companyVehiclesCount !== undefined) ||
          (originalMetadata?.coverages.companyVehiclesCount !== null &&
            originalMetadata?.coverages.companyVehiclesCount !== undefined)
        "
      >
        <span class="card__label" i18n>Nombre de véhicules entreprise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.coverages.companyVehiclesCount !==
                  metadata?.coverages.companyVehiclesCount,
            }"
            >{{ metadata?.coverages.companyVehiclesCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.coverages.companyVehiclesCount !==
                metadata?.coverages.companyVehiclesCount &&
              originalMetadata?.coverages.companyVehiclesCount !== null &&
              originalMetadata?.coverages.companyVehiclesCount !== undefined
            "
            >{{ originalMetadata?.coverages.companyVehiclesCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.realEstate !== null &&
            metadata?.coverages.realEstate !== undefined) ||
          (originalMetadata?.coverages.realEstate !== null &&
            originalMetadata?.coverages.realEstate !== undefined)
        "
      >
        <span class="card__label" i18n>PJ immobilière</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.coverages.realEstate) !==
                  getBooleanLabel(metadata?.coverages.realEstate),
            }"
            >{{ getBooleanLabel(metadata?.coverages.realEstate) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.coverages.realEstate) !==
                getBooleanLabel(metadata?.coverages.realEstate) &&
              getBooleanLabel(originalMetadata?.coverages.realEstate) !==
                null &&
              getBooleanLabel(originalMetadata?.coverages.realEstate) !==
                undefined
            "
            >{{ getBooleanLabel(originalMetadata?.coverages.realEstate) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.insuredSumPerClaim !== null &&
            metadata?.coverages.insuredSumPerClaim !== undefined) ||
          (originalMetadata?.coverages.insuredSumPerClaim !== null &&
            originalMetadata?.coverages.insuredSumPerClaim !== undefined)
        "
      >
        <span class="card__label" i18n>Somme garantie par sinistre</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.coverages.insuredSumPerClaim !==
                  metadata?.coverages.insuredSumPerClaim,
            }"
            >{{ metadata?.coverages.insuredSumPerClaim }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.coverages.insuredSumPerClaim !==
                metadata?.coverages.insuredSumPerClaim &&
              originalMetadata?.coverages.insuredSumPerClaim !== null &&
              originalMetadata?.coverages.insuredSumPerClaim !== undefined
            "
            >{{ originalMetadata?.coverages.insuredSumPerClaim }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.insuredSumContracts !== null &&
            metadata?.coverages.insuredSumContracts !== undefined) ||
          (originalMetadata?.coverages.insuredSumContracts !== null &&
            originalMetadata?.coverages.insuredSumContracts !== undefined)
        "
      >
        <span class="card__label" i18n
          >Somme garantie en matière contractuelle</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.coverages.insuredSumContracts !==
                  metadata?.coverages.insuredSumContracts,
            }"
            >{{ metadata?.coverages.insuredSumContracts }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.coverages.insuredSumContracts !==
                metadata?.coverages.insuredSumContracts &&
              originalMetadata?.coverages.insuredSumContracts !== null &&
              originalMetadata?.coverages.insuredSumContracts !== undefined
            "
            >{{ originalMetadata?.coverages.insuredSumContracts }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.deductibleContracts !== null &&
            metadata?.coverages.deductibleContracts !== undefined) ||
          (originalMetadata?.coverages.deductibleContracts !== null &&
            originalMetadata?.coverages.deductibleContracts !== undefined)
        "
      >
        <span class="card__label" i18n
          >Franchise en couverture contractuelle</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.coverages.deductibleContracts !==
                  metadata?.coverages.deductibleContracts,
            }"
            >{{ metadata?.coverages.deductibleContracts }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.coverages.deductibleContracts !==
                metadata?.coverages.deductibleContracts &&
              originalMetadata?.coverages.deductibleContracts !== null &&
              originalMetadata?.coverages.deductibleContracts !== undefined
            "
            >{{ originalMetadata?.coverages.deductibleContracts }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.insuredSumInternational !== null &&
            metadata?.coverages.insuredSumInternational !== undefined) ||
          (originalMetadata?.coverages.insuredSumInternational !== null &&
            originalMetadata?.coverages.insuredSumInternational !== undefined)
        "
      >
        <span class="card__label" i18n
          >Somme garantie pour la couverture internationale</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.coverages.insuredSumInternational !==
                  metadata?.coverages.insuredSumInternational,
            }"
            >{{ metadata?.coverages.insuredSumInternational }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.coverages.insuredSumInternational !==
                metadata?.coverages.insuredSumInternational &&
              originalMetadata?.coverages.insuredSumInternational !== null &&
              originalMetadata?.coverages.insuredSumInternational !== undefined
            "
            >{{ originalMetadata?.coverages.insuredSumInternational }} CHF</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.earningsLossReimbursement !== null &&
            metadata?.coverages.earningsLossReimbursement !== undefined) ||
          (originalMetadata?.coverages.earningsLossReimbursement !== null &&
            originalMetadata?.coverages.earningsLossReimbursement !== undefined)
        "
      >
        <span class="card__label" i18n
          >Indemnisation de la perte de salaire due à la procédure</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.earningsLossReimbursement
                ) !==
                  getBooleanLabel(
                    !!metadata?.coverages.earningsLossReimbursement
                  ),
            }"
            >{{
              getBooleanLabel(!!metadata?.coverages.earningsLossReimbursement)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                !!originalMetadata?.coverages.earningsLossReimbursement
              ) !==
                getBooleanLabel(
                  !!metadata?.coverages.earningsLossReimbursement
                ) &&
              getBooleanLabel(
                !!originalMetadata?.coverages.earningsLossReimbursement
              ) !== null &&
              getBooleanLabel(
                !!originalMetadata?.coverages.earningsLossReimbursement
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                !!originalMetadata?.coverages.earningsLossReimbursement
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.travelExpensesReimbursement !== null &&
            metadata?.coverages.travelExpensesReimbursement !== undefined) ||
          (originalMetadata?.coverages.travelExpensesReimbursement !== null &&
            originalMetadata?.coverages.travelExpensesReimbursement !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Indemnisation des frais de déplacement dus à la procédure</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.travelExpensesReimbursement
                ) !==
                  getBooleanLabel(
                    !!metadata?.coverages.travelExpensesReimbursement
                  ),
            }"
            >{{
              getBooleanLabel(!!metadata?.coverages.travelExpensesReimbursement)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                !!originalMetadata?.coverages.travelExpensesReimbursement
              ) !==
                getBooleanLabel(
                  !!metadata?.coverages.travelExpensesReimbursement
                ) &&
              getBooleanLabel(
                !!originalMetadata?.coverages.travelExpensesReimbursement
              ) !== null &&
              getBooleanLabel(
                !!originalMetadata?.coverages.travelExpensesReimbursement
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                !!originalMetadata?.coverages.travelExpensesReimbursement
              )
            }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.companyFurnitureContract !== null &&
            metadata?.coverages.companyFurnitureContract !== undefined) ||
          (originalMetadata?.coverages.companyFurnitureContract !== null &&
            originalMetadata?.coverages.companyFurnitureContract !== undefined)
        "
      >
        <span class="card__label" i18n
          >Contrats portant sur le mobilier de l'entreprise</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.companyFurnitureContract
                ) !==
                  getBooleanLabel(
                    !!metadata?.coverages.companyFurnitureContract
                  ),
            }"
            >{{
              getBooleanLabel(!!metadata?.coverages.companyFurnitureContract)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                !!originalMetadata?.coverages.companyFurnitureContract
              ) !==
                getBooleanLabel(
                  !!metadata?.coverages.companyFurnitureContract
                ) &&
              getBooleanLabel(
                !!originalMetadata?.coverages.companyFurnitureContract
              ) !== null &&
              getBooleanLabel(
                !!originalMetadata?.coverages.companyFurnitureContract
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                !!originalMetadata?.coverages.companyFurnitureContract
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.taxLaw !== null &&
            metadata?.coverages.taxLaw !== undefined) ||
          (originalMetadata?.coverages.taxLaw !== null &&
            originalMetadata?.coverages.taxLaw !== undefined)
        "
      >
        <span class="card__label" i18n>Droit fiscal</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.taxLaw) !==
                  getBooleanLabel(!!metadata?.coverages.taxLaw),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.taxLaw) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.taxLaw) !==
                getBooleanLabel(!!metadata?.coverages.taxLaw) &&
              getBooleanLabel(!!originalMetadata?.coverages.taxLaw) !== null &&
              getBooleanLabel(!!originalMetadata?.coverages.taxLaw) !==
                undefined
            "
            >{{ getBooleanLabel(!!originalMetadata?.coverages.taxLaw) }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.neighborhoodLaw !== null &&
            metadata?.coverages.neighborhoodLaw !== undefined) ||
          (originalMetadata?.coverages.neighborhoodLaw !== null &&
            originalMetadata?.coverages.neighborhoodLaw !== undefined)
        "
      >
        <span class="card__label" i18n>Droit du voisinage</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.neighborhoodLaw
                ) !== getBooleanLabel(!!metadata?.coverages.neighborhoodLaw),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.neighborhoodLaw) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.neighborhoodLaw) !==
                getBooleanLabel(!!metadata?.coverages.neighborhoodLaw) &&
              getBooleanLabel(!!originalMetadata?.coverages.neighborhoodLaw) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.neighborhoodLaw) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.neighborhoodLaw)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.expropriation !== null &&
            metadata?.coverages.expropriation !== undefined) ||
          (originalMetadata?.coverages.expropriation !== null &&
            originalMetadata?.coverages.expropriation !== undefined)
        "
      >
        <span class="card__label" i18n>Expropriation formelle</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.expropriation) !==
                  getBooleanLabel(!!metadata?.coverages.expropriation),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.expropriation) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.expropriation) !==
                getBooleanLabel(!!metadata?.coverages.expropriation) &&
              getBooleanLabel(!!originalMetadata?.coverages.expropriation) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.expropriation) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.expropriation)
            }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.customerSupplierContractsLaw !== null &&
            metadata?.coverages.customerSupplierContractsLaw !== undefined) ||
          (originalMetadata?.coverages.customerSupplierContractsLaw !== null &&
            originalMetadata?.coverages.customerSupplierContractsLaw !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Contrats avec les clients et les fournisseurs</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.customerSupplierContractsLaw
                ) !==
                  getBooleanLabel(
                    !!metadata?.coverages.customerSupplierContractsLaw
                  ),
            }"
            >{{
              getBooleanLabel(
                !!metadata?.coverages.customerSupplierContractsLaw
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                !!originalMetadata?.coverages.customerSupplierContractsLaw
              ) !==
                getBooleanLabel(
                  !!metadata?.coverages.customerSupplierContractsLaw
                ) &&
              getBooleanLabel(
                !!originalMetadata?.coverages.customerSupplierContractsLaw
              ) !== null &&
              getBooleanLabel(
                !!originalMetadata?.coverages.customerSupplierContractsLaw
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                !!originalMetadata?.coverages.customerSupplierContractsLaw
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.damagesClaims !== null &&
            metadata?.coverages.damagesClaims !== undefined) ||
          (originalMetadata?.coverages.damagesClaims !== null &&
            originalMetadata?.coverages.damagesClaims !== undefined)
        "
      >
        <span class="card__label" i18n
          >Prétentions en dommages et intérêts</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.damagesClaims) !==
                  getBooleanLabel(!!metadata?.coverages.damagesClaims),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.damagesClaims) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.damagesClaims) !==
                getBooleanLabel(!!metadata?.coverages.damagesClaims) &&
              getBooleanLabel(!!originalMetadata?.coverages.damagesClaims) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.damagesClaims) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.damagesClaims)
            }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.criminalLaw !== null &&
            metadata?.coverages.criminalLaw !== undefined) ||
          (originalMetadata?.coverages.criminalLaw !== null &&
            originalMetadata?.coverages.criminalLaw !== undefined)
        "
      >
        <span class="card__label" i18n>Droit pénal et droit administratif</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.criminalLaw) !==
                  getBooleanLabel(!!metadata?.coverages.criminalLaw),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.criminalLaw) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.criminalLaw) !==
                getBooleanLabel(!!metadata?.coverages.criminalLaw) &&
              getBooleanLabel(!!originalMetadata?.coverages.criminalLaw) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.criminalLaw) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.criminalLaw)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.administrativeLaw !== null &&
            metadata?.coverages.administrativeLaw !== undefined) ||
          (originalMetadata?.coverages.administrativeLaw !== null &&
            originalMetadata?.coverages.administrativeLaw !== undefined)
        "
      >
        <span class="card__label" i18n
          >Droit administratif, autorisation d'exploiter</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.administrativeLaw
                ) !== getBooleanLabel(!!metadata?.coverages.administrativeLaw),
            }"
            >{{
              getBooleanLabel(!!metadata?.coverages.administrativeLaw)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                !!originalMetadata?.coverages.administrativeLaw
              ) !== getBooleanLabel(!!metadata?.coverages.administrativeLaw) &&
              getBooleanLabel(
                !!originalMetadata?.coverages.administrativeLaw
              ) !== null &&
              getBooleanLabel(
                !!originalMetadata?.coverages.administrativeLaw
              ) !== undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.administrativeLaw)
            }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.legalAdvice !== null &&
            metadata?.coverages.legalAdvice !== undefined) ||
          (originalMetadata?.coverages.legalAdvice !== null &&
            originalMetadata?.coverages.legalAdvice !== undefined)
        "
      >
        <span class="card__label" i18n
          >Conseils juridiques oraux et écrits illimités</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.legalAdvice) !==
                  getBooleanLabel(!!metadata?.coverages.legalAdvice),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.legalAdvice) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.legalAdvice) !==
                getBooleanLabel(!!metadata?.coverages.legalAdvice) &&
              getBooleanLabel(!!originalMetadata?.coverages.legalAdvice) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.legalAdvice) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.legalAdvice)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.insurancesLaw !== null &&
            metadata?.coverages.insurancesLaw !== undefined) ||
          (originalMetadata?.coverages.insurancesLaw !== null &&
            originalMetadata?.coverages.insurancesLaw !== undefined)
        "
      >
        <span class="card__label" i18n
          >Droit des assurances sociales et privées</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.insurancesLaw) !==
                  getBooleanLabel(!!metadata?.coverages.insurancesLaw),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.insurancesLaw) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.insurancesLaw) !==
                getBooleanLabel(!!metadata?.coverages.insurancesLaw) &&
              getBooleanLabel(!!originalMetadata?.coverages.insurancesLaw) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.insurancesLaw) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.insurancesLaw)
            }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.legalActionLaw !== null &&
            metadata?.coverages.legalActionLaw !== undefined) ||
          (originalMetadata?.coverages.legalActionLaw !== null &&
            originalMetadata?.coverages.legalActionLaw !== undefined)
        "
      >
        <span class="card__label" i18n>Droit d'attaquer en justice</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.legalActionLaw
                ) !== getBooleanLabel(!!metadata?.coverages.legalActionLaw),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.legalActionLaw) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.legalActionLaw) !==
                getBooleanLabel(!!metadata?.coverages.legalActionLaw) &&
              getBooleanLabel(!!originalMetadata?.coverages.legalActionLaw) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.legalActionLaw) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.legalActionLaw)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.tenancyLaw !== null &&
            metadata?.coverages.tenancyLaw !== undefined) ||
          (originalMetadata?.coverages.tenancyLaw !== null &&
            originalMetadata?.coverages.tenancyLaw !== undefined)
        "
      >
        <span class="card__label" i18n>Droit du bail à loyer et à ferme</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.tenancyLaw) !==
                  getBooleanLabel(!!metadata?.coverages.tenancyLaw),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.tenancyLaw) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.tenancyLaw) !==
                getBooleanLabel(!!metadata?.coverages.tenancyLaw) &&
              getBooleanLabel(!!originalMetadata?.coverages.tenancyLaw) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.tenancyLaw) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.tenancyLaw)
            }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.laborLaw !== null &&
            metadata?.coverages.laborLaw !== undefined) ||
          (originalMetadata?.coverages.laborLaw !== null &&
            originalMetadata?.coverages.laborLaw !== undefined)
        "
      >
        <span class="card__label" i18n>Droit du travail</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.laborLaw) !==
                  getBooleanLabel(!!metadata?.coverages.laborLaw),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.laborLaw) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.laborLaw) !==
                getBooleanLabel(!!metadata?.coverages.laborLaw) &&
              getBooleanLabel(!!originalMetadata?.coverages.laborLaw) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.laborLaw) !==
                undefined
            "
            >{{ getBooleanLabel(!!originalMetadata?.coverages.laborLaw) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.professionalAssociationsDisputes !== null &&
            metadata?.coverages.professionalAssociationsDisputes !==
              undefined) ||
          (originalMetadata?.coverages.professionalAssociationsDisputes !==
            null &&
            originalMetadata?.coverages.professionalAssociationsDisputes !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Litiges avec les associations professionnelles</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.professionalAssociationsDisputes
                ) !==
                  getBooleanLabel(
                    !!metadata?.coverages.professionalAssociationsDisputes
                  ),
            }"
            >{{
              getBooleanLabel(
                !!metadata?.coverages.professionalAssociationsDisputes
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                !!originalMetadata?.coverages.professionalAssociationsDisputes
              ) !==
                getBooleanLabel(
                  !!metadata?.coverages.professionalAssociationsDisputes
                ) &&
              getBooleanLabel(
                !!originalMetadata?.coverages.professionalAssociationsDisputes
              ) !== null &&
              getBooleanLabel(
                !!originalMetadata?.coverages.professionalAssociationsDisputes
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                !!originalMetadata?.coverages.professionalAssociationsDisputes
              )
            }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.interiorTransformation !== null &&
            metadata?.coverages.interiorTransformation !== undefined) ||
          (originalMetadata?.coverages.interiorTransformation !== null &&
            originalMetadata?.coverages.interiorTransformation !== undefined)
        "
      >
        <span class="card__label" i18n
          >Transformation intérieure des immeubles de l'entreprise</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.interiorTransformation
                ) !==
                  getBooleanLabel(!!metadata?.coverages.interiorTransformation),
            }"
            >{{
              getBooleanLabel(!!metadata?.coverages.interiorTransformation)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                !!originalMetadata?.coverages.interiorTransformation
              ) !==
                getBooleanLabel(!!metadata?.coverages.interiorTransformation) &&
              getBooleanLabel(
                !!originalMetadata?.coverages.interiorTransformation
              ) !== null &&
              getBooleanLabel(
                !!originalMetadata?.coverages.interiorTransformation
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                !!originalMetadata?.coverages.interiorTransformation
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.unfairCompetitionDisputes !== null &&
            metadata?.coverages.unfairCompetitionDisputes !== undefined) ||
          (originalMetadata?.coverages.unfairCompetitionDisputes !== null &&
            originalMetadata?.coverages.unfairCompetitionDisputes !== undefined)
        "
      >
        <span class="card__label" i18n
          >Litiges en matières de concurrence déloyale</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.unfairCompetitionDisputes
                ) !==
                  getBooleanLabel(
                    !!metadata?.coverages.unfairCompetitionDisputes
                  ),
            }"
            >{{
              getBooleanLabel(!!metadata?.coverages.unfairCompetitionDisputes)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                !!originalMetadata?.coverages.unfairCompetitionDisputes
              ) !==
                getBooleanLabel(
                  !!metadata?.coverages.unfairCompetitionDisputes
                ) &&
              getBooleanLabel(
                !!originalMetadata?.coverages.unfairCompetitionDisputes
              ) !== null &&
              getBooleanLabel(
                !!originalMetadata?.coverages.unfairCompetitionDisputes
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                !!originalMetadata?.coverages.unfairCompetitionDisputes
              )
            }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.realEstateLaw !== null &&
            metadata?.coverages.realEstateLaw !== undefined) ||
          (originalMetadata?.coverages.realEstateLaw !== null &&
            originalMetadata?.coverages.realEstateLaw !== undefined)
        "
      >
        <span class="card__label" i18n
          >PJ immobilière des locaux de l'entreprise</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.realEstateLaw) !==
                  getBooleanLabel(!!metadata?.coverages.realEstateLaw),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.realEstateLaw) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.realEstateLaw) !==
                getBooleanLabel(!!metadata?.coverages.realEstateLaw) &&
              getBooleanLabel(!!originalMetadata?.coverages.realEstateLaw) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.realEstateLaw) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.realEstateLaw)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.landCharges !== null &&
            metadata?.coverages.landCharges !== undefined) ||
          (originalMetadata?.coverages.landCharges !== null &&
            originalMetadata?.coverages.landCharges !== undefined)
        "
      >
        <span class="card__label" i18n>Servitudes et charges foncières</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.landCharges) !==
                  getBooleanLabel(!!metadata?.coverages.landCharges),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.landCharges) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.landCharges) !==
                getBooleanLabel(!!metadata?.coverages.landCharges) &&
              getBooleanLabel(!!originalMetadata?.coverages.landCharges) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.landCharges) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.landCharges)
            }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.constructionPermitOpposition !== null &&
            metadata?.coverages.constructionPermitOpposition !== undefined) ||
          (originalMetadata?.coverages.constructionPermitOpposition !== null &&
            originalMetadata?.coverages.constructionPermitOpposition !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Opposition contre les permis de construire</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.constructionPermitOpposition
                ) !==
                  getBooleanLabel(
                    !!metadata?.coverages.constructionPermitOpposition
                  ),
            }"
            >{{
              getBooleanLabel(
                !!metadata?.coverages.constructionPermitOpposition
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                !!originalMetadata?.coverages.constructionPermitOpposition
              ) !==
                getBooleanLabel(
                  !!metadata?.coverages.constructionPermitOpposition
                ) &&
              getBooleanLabel(
                !!originalMetadata?.coverages.constructionPermitOpposition
              ) !== null &&
              getBooleanLabel(
                !!originalMetadata?.coverages.constructionPermitOpposition
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                !!originalMetadata?.coverages.constructionPermitOpposition
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.internetProtection !== null &&
            metadata?.coverages.internetProtection !== undefined) ||
          (originalMetadata?.coverages.internetProtection !== null &&
            originalMetadata?.coverages.internetProtection !== undefined)
        "
      >
        <span class="card__label" i18n>PJ internet</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  !!originalMetadata?.coverages.internetProtection
                ) !== getBooleanLabel(!!metadata?.coverages.internetProtection),
            }"
            >{{
              getBooleanLabel(!!metadata?.coverages.internetProtection)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                !!originalMetadata?.coverages.internetProtection
              ) !== getBooleanLabel(!!metadata?.coverages.internetProtection) &&
              getBooleanLabel(
                !!originalMetadata?.coverages.internetProtection
              ) !== null &&
              getBooleanLabel(
                !!originalMetadata?.coverages.internetProtection
              ) !== undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.internetProtection)
            }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.imageRights !== null &&
            metadata?.coverages.imageRights !== undefined) ||
          (originalMetadata?.coverages.imageRights !== null &&
            originalMetadata?.coverages.imageRights !== undefined)
        "
      >
        <span class="card__label" i18n>Défense du droit à l'image</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.imageRights) !==
                  getBooleanLabel(!!metadata?.coverages.imageRights),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.imageRights) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.imageRights) !==
                getBooleanLabel(!!metadata?.coverages.imageRights) &&
              getBooleanLabel(!!originalMetadata?.coverages.imageRights) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.imageRights) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.imageRights)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages.copyrights !== null &&
            metadata?.coverages.copyrights !== undefined) ||
          (originalMetadata?.coverages.copyrights !== null &&
            originalMetadata?.coverages.copyrights !== undefined)
        "
      >
        <span class="card__label" i18n
          >Droits des marques - Droits d'auteur</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(!!originalMetadata?.coverages.copyrights) !==
                  getBooleanLabel(!!metadata?.coverages.copyrights),
            }"
            >{{ getBooleanLabel(!!metadata?.coverages.copyrights) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(!!originalMetadata?.coverages.copyrights) !==
                getBooleanLabel(!!metadata?.coverages.copyrights) &&
              getBooleanLabel(!!originalMetadata?.coverages.copyrights) !==
                null &&
              getBooleanLabel(!!originalMetadata?.coverages.copyrights) !==
                undefined
            "
            >{{
              getBooleanLabel(!!originalMetadata?.coverages.copyrights)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.territorialCoverages) ||
    !isSectionEmpty(originalMetadata?.territorialCoverages)
  "
>
  <div cardTitle i18n>Couvertures territoriales</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.territorialCoverages.basicCoverage !== null &&
            metadata?.territorialCoverages.basicCoverage !== undefined) ||
          (originalMetadata?.territorialCoverages.basicCoverage !== null &&
            originalMetadata?.territorialCoverages.basicCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture de base</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.territorialCoverages.basicCoverage
                ) !==
                  getBooleanLabel(metadata?.territorialCoverages.basicCoverage),
            }"
            >{{
              getBooleanLabel(metadata?.territorialCoverages.basicCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.basicCoverage
              ) !==
                getBooleanLabel(metadata?.territorialCoverages.basicCoverage) &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.basicCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.basicCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.territorialCoverages.basicCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.territorialCoverages.extendedContractualCoverage !==
            null &&
            metadata?.territorialCoverages.extendedContractualCoverage !==
              undefined) ||
          (originalMetadata?.territorialCoverages
            .extendedContractualCoverage !== null &&
            originalMetadata?.territorialCoverages
              .extendedContractualCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture contractuelle étendue</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.territorialCoverages
                    .extendedContractualCoverage
                ) !==
                  getBooleanLabel(
                    metadata?.territorialCoverages.extendedContractualCoverage
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata?.territorialCoverages.extendedContractualCoverage
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages
                  .extendedContractualCoverage
              ) !==
                getBooleanLabel(
                  metadata?.territorialCoverages.extendedContractualCoverage
                ) &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages
                  .extendedContractualCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages
                  .extendedContractualCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.territorialCoverages
                  .extendedContractualCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.territorialCoverages.accident !== null &&
            metadata?.territorialCoverages.accident !== undefined) ||
          (originalMetadata?.territorialCoverages.accident !== null &&
            originalMetadata?.territorialCoverages.accident !== undefined)
        "
      >
        <span class="card__label" i18n>Risque accident</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.territorialCoverages.accident
                ) !== getBooleanLabel(metadata?.territorialCoverages.accident),
            }"
            >{{
              getBooleanLabel(metadata?.territorialCoverages.accident)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.accident
              ) !== getBooleanLabel(metadata?.territorialCoverages.accident) &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.accident
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.accident
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.territorialCoverages.accident)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.territorialCoverages.trip !== null &&
            metadata?.territorialCoverages.trip !== undefined) ||
          (originalMetadata?.territorialCoverages.trip !== null &&
            originalMetadata?.territorialCoverages.trip !== undefined)
        "
      >
        <span class="card__label" i18n>Risque voyage</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.territorialCoverages.trip) !==
                  getBooleanLabel(metadata?.territorialCoverages.trip),
            }"
            >{{ getBooleanLabel(metadata?.territorialCoverages.trip) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.territorialCoverages.trip) !==
                getBooleanLabel(metadata?.territorialCoverages.trip) &&
              getBooleanLabel(originalMetadata?.territorialCoverages.trip) !==
                null &&
              getBooleanLabel(originalMetadata?.territorialCoverages.trip) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.territorialCoverages.trip)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.territorialCoverages.roadTraffic !== null &&
            metadata?.territorialCoverages.roadTraffic !== undefined) ||
          (originalMetadata?.territorialCoverages.roadTraffic !== null &&
            originalMetadata?.territorialCoverages.roadTraffic !== undefined)
        "
      >
        <span class="card__label" i18n>PJ circulation</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.territorialCoverages.roadTraffic
                ) !==
                  getBooleanLabel(metadata?.territorialCoverages.roadTraffic),
            }"
            >{{
              getBooleanLabel(metadata?.territorialCoverages.roadTraffic)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.roadTraffic
              ) !==
                getBooleanLabel(metadata?.territorialCoverages.roadTraffic) &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.roadTraffic
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.roadTraffic
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.territorialCoverages.roadTraffic
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.territorialCoverages.realEstate !== null &&
            metadata?.territorialCoverages.realEstate !== undefined) ||
          (originalMetadata?.territorialCoverages.realEstate !== null &&
            originalMetadata?.territorialCoverages.realEstate !== undefined)
        "
      >
        <span class="card__label" i18n>PJ immobilière</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.territorialCoverages.realEstate
                ) !==
                  getBooleanLabel(metadata?.territorialCoverages.realEstate),
            }"
            >{{
              getBooleanLabel(metadata?.territorialCoverages.realEstate)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.realEstate
              ) !==
                getBooleanLabel(metadata?.territorialCoverages.realEstate) &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.realEstate
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.territorialCoverages.realEstate
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.territorialCoverages.realEstate)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
